import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import { InstallableUrlMessage, InstallableUrlMessageVariables } from './__generated__/InstallableUrlMessage'

const QUERY = gql`
  query InstallableUrlMessage($installableId: String!) {
    installableUrlMessageV2(installableId: $installableId) {
      ... on InstallableUrlMessageV2 {
        installableId
        name
        slug
        urlMessage
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetInstallableUrlMessage = (installableId: string) => {
  return useQuery<InstallableUrlMessage, InstallableUrlMessageVariables>(QUERY, {
    variables: {
      installableId
    }
  })
}
